import React, { useState,useEffect } from "react";
import { Link, useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { Tooltip } from "react-tooltip";
import CheckCurrentPlan from "../../../../components/CheckCurrentPlan";
import { submitTemplate, updateTemplateDetail } from "../../../../utils/teamShowcaseApi";
import '../../../../assets/css/loader.css'; 

//Import Widgets
import CompanyStructureTemplateWidget from "../../../../components/Apps/TeamShowcase/Template/CompanyStructureTemplateWidget";
import SmallTeamTemplateWidget from "../../../../components/Apps/TeamShowcase/Template/SmallTeamTemplateWidget";
import DedicatedTeamTemplateWidget from "../../../../components/Apps/TeamShowcase/Template/DedicatedTeamTemplateWidget";
import MusicBandTemplateWidget from "../../../../components/Apps/TeamShowcase/Template/MusicBandTemplateWidget";
import TeamRosterTemplateWidget from "../../../../components/Apps/TeamShowcase/Template/TeamRosterTemplateWidget";
import TeachersTemplateWidget from "../../../../components/Apps/TeamShowcase/Template/TeachersTemplateWidget";

//Import Tabs
import ContentTab from "../../../../components/Apps/TeamShowcase/ContentTab";
import LayoutTab from "../../../../components/Apps/TeamShowcase/LayoutTab";
import StyleTab from "../../../../components/Apps/TeamShowcase/StyleTab";
import SettingsTab from "../../../../components/Apps/TeamShowcase/SettingTab";

export default function CreateTeamShowcase() {
    const navigate = useNavigate();
    const [isSubmitting, setIsSubmitting] = useState(true);
    const [showTemplateSelection, setShowTemplateSelection] = useState(true);
    const [activeSection, setActiveSection] = useState("Content");
    const [activeTemplateSection, setActiveTemplateSection] = useState("Company_Structure_Temp");
    const [selectedLayout, setSelectedLayout] = useState("company_structure_layout");
    const [selectedTemplateImage, setSelectedTemplateImage] = useState("company-structure.png");
    const [renameWidgetNameModel, setRenameWidgetNameModel] = useState(false);
    const [widgetName, setWidgetName] = useState("Untitled Team Showcase");
    const [isTemplateId, setTemplateId] = useState(null);
    const [newWidgetName, setNewWidgetName] = useState("");
    const [refreshWidgetList, setRefreshWidgetList] = useState(false);
    
    const [teamShowcaseTabData, setTeamShowcaseTabData] = useState({
        is_website_frontend: "",  
        is_show_header: 1,
        header_title: "",
        header_caption: "",
        is_call_to_action: 1,
        call_to_action_title: "",
        call_to_action_button_text: "",      
        call_to_action_button_link: "",   
        layout_is_full_width: 0,     
        layout_custom_width: "1280", 
        text_align_type: "center",   
        member_background_color: "",   
        text_color: "",   
        links_color: "",   
        call_to_action_button_color: "",   
        widget_background_color: "",   
        font_type: "Default",   
        widget_align_type: "center",   
        widget_title_color: "",   
        widget_caption_color: "",   
        widget_links_color: "", 
        widget_title_size: "24px",   
        widget_caption_size: "16px",  
        popup_background_color: "",  
        popup_text_color: "",  
        popup_links_color: "",  
        message_text_type: "",  
        custom_css: "",   
        custom_js: "",   
    });

    // Set Template Setting And Texts when activeTemplateSection changes
        useEffect(() => {
            let header_title = "";
            let header_caption = "";
            let call_to_action_title = "";
            let call_to_action_button_text = "";
            let member_background_color = "";
            let text_color = "";  
            let links_color = "";   
            let call_to_action_button_color = ""; 
            let widget_background_color = ""; 
            let widget_title_color = ""; 
            let widget_caption_color = ""; 
            let widget_links_color = ""; 
            let popup_background_color = ""; 
            let popup_text_color = ""; 
            let popup_links_color = ""; 
            let message_text_type = ""; 
        
            switch (activeTemplateSection) {
                case "Company_Structure_Temp":
                    header_title = "Meet Our Team";
                    header_caption = "";
                    call_to_action_title = "Join our growing team";
                    call_to_action_button_text = "See Job Openings";
                    member_background_color = "#f8f8f8";
                    text_color = "#111";
                    links_color = "#000";
                    call_to_action_button_color = "linear-gradient(131deg, #fe8100 -4.12%, #f5ff00)";
                    widget_background_color = "#f8f8f8";
                    widget_title_color = "#000";
                    widget_caption_color = "#000";
                    widget_links_color = "#000";
                    popup_background_color = "#fff";
                    popup_text_color = "#000";
                    popup_links_color = "#000";
                    message_text_type = "See Info";
                    break;
                case "Small_Team_Temp":
                    header_title = "Meet Our Team";
                    header_caption = "";
                    call_to_action_title = "";
                    call_to_action_button_text = "";
                    member_background_color = "#f8f8f8";
                    text_color = "#111";
                    links_color = "#000";
                    call_to_action_button_color = "linear-gradient(131deg, #fe8100 -4.12%, #f5ff00)";
                    widget_background_color = "#f8f8f8";
                    widget_title_color = "#000";
                    widget_caption_color = "#000";
                    widget_links_color = "#000";
                    popup_background_color = "#fff";
                    popup_text_color = "#000";
                    popup_links_color = "#000";
                    message_text_type = "";
                    break;
                case "Dedicated_Team_Temp":
                    header_title = "";
                    header_caption = "";
                    call_to_action_title = "";
                    call_to_action_button_text = "";
                    member_background_color = "#f8f8f8";
                    text_color = "#111";
                    links_color = "#000";
                    call_to_action_button_color = "linear-gradient(131deg, #fe8100 -4.12%, #f5ff00)";
                    widget_background_color = "#f8f8f8";
                    widget_title_color = "#000";
                    widget_caption_color = "#000";
                    widget_links_color = "#000";
                    popup_background_color = "#fff";
                    popup_text_color = "#000";
                    popup_links_color = "#000";
                    message_text_type = "";
                    break;
                case "Music_Band_Temp":
                    header_title = "";
                    header_caption = "";
                    call_to_action_title = "";
                    call_to_action_button_text = "";
                    member_background_color = "#f8f8f8";
                    text_color = "#fff";
                    links_color = "#000";
                    call_to_action_button_color = "linear-gradient(131deg, #fe8100 -4.12%, #f5ff00)";
                    widget_background_color = "#2b6965";
                    widget_title_color = "#fff";
                    widget_caption_color = "#fff";
                    widget_links_color = "#000";
                    popup_background_color = "#fff";
                    popup_text_color = "#000";
                    popup_links_color = "#000";
                    message_text_type = "";
                    break;
                case "Team_Roster_Temp":
                    header_title = "Meet Our Team";
                    header_caption = "";
                    call_to_action_title = "";
                    call_to_action_button_text = "View";
                    member_background_color = "#bc6901";
                    text_color = "#fff";
                    links_color = "#fff";
                    call_to_action_button_color = "#000";
                    widget_background_color = "#FE8100";
                    widget_title_color = "#fff";
                    widget_caption_color = "#fff";
                    widget_links_color = "#fff";
                    popup_background_color = "#fff";
                    popup_text_color = "#000";
                    popup_links_color = "#000";
                    message_text_type = "";
                    break;
                case "Teachers_Temp":
                    header_title = "Meet Our Team";
                    header_caption = "";
                    call_to_action_title = "";
                    call_to_action_button_text = "View More";
                    member_background_color = "#f8f8f8";
                    text_color = "#000";
                    links_color = "rgba(var(--bs-link-color-rgb),var(--bs-link-opacity,1))";
                    call_to_action_button_color = "#f8f8f8";
                    widget_background_color = "#f8f8f8";
                    widget_title_color = "#000";
                    widget_caption_color = "#000";
                    widget_links_color = "#fff";
                    popup_background_color = "#fff";
                    popup_text_color = "#000";
                    popup_links_color = "#000";
                    message_text_type = "";
                    break;
                default:
                    header_title = "";
                    header_caption = "";
                    call_to_action_title = "";
                    call_to_action_button_text = "";
                    member_background_color = "";
                    text_color = "";
                    links_color = "";
                    call_to_action_button_color = "";
                    widget_background_color = "";
                    widget_title_color = "";
                    widget_caption_color = "";
                    widget_links_color = "";
                    popup_background_color = "";
                    popup_text_color = "";
                    popup_links_color = "";
                    message_text_type = "See Info";
            }
        
            // Update setTeamShowcaseTabData state with the data
            setTeamShowcaseTabData((prevData) => ({
                ...prevData,
                header_title: header_title,
                header_caption: header_caption,
                call_to_action_title: call_to_action_title,
                call_to_action_button_text: call_to_action_button_text,
                member_background_color: member_background_color,
                text_color: text_color,
                links_color: links_color,
                call_to_action_button_color: call_to_action_button_color,
                widget_background_color: widget_background_color,
                widget_title_color: widget_title_color,
                widget_caption_color: widget_caption_color,
                widget_links_color: widget_links_color,
                popup_background_color: popup_background_color,
                popup_text_color: popup_text_color,
                popup_links_color: popup_links_color,
                message_text_type: message_text_type,
            }));
        
        }, [activeTemplateSection]);

    // Open Widget Name Popup
    const openRenameWidgetNamePopup = () => {
        setNewWidgetName(widgetName);
        setRenameWidgetNameModel(true);
        document.body.classList.add("popup-open");
    };

    // Close Widget Name Popup
    const closeRenameWidgetNamePopup = () => {
        setRenameWidgetNameModel(false);
        document.body.classList.remove("popup-open");
    };

    // Save Widget Name Popup
    const saveWidgetName = () => {
        if (newWidgetName.trim() !== "") {
            setWidgetName(newWidgetName); 
        }
        closeRenameWidgetNamePopup();
    };

    // Function to update values dynamically
    const updateTeamShowcaseTabData = (key, value) => {
        setTeamShowcaseTabData((prev) => ({
            ...prev,
            [key]: value,
        }));
    };

    const handleContinueTemplate = async () => {
        setShowTemplateSelection(false);
        setIsSubmitting(false);
        //Get the currently checked radio button
        const selectedRadio = document.querySelector('input[name="app_template_type"]:checked');
        if (selectedRadio) {
            const layoutTypeValue = selectedRadio.dataset.layout_type;
            setSelectedLayout(layoutTypeValue);
        } else {
            alert('Please select a template');
        } 

       //Call Api To Create Templates with dummy data first
        try {
            // Collect data from refs
            const settingsArray = Object.entries(teamShowcaseTabData).map(([key, value]) => ({
                setting_key: key,
                setting_value: value,
            }));

            // Collect data from refs
            const payload = {
                    name: widgetName,
                    template_name: activeTemplateSection,
                    template_image: selectedTemplateImage,
                    layout_name: selectedLayout,
                    layout_type: selectedLayout,
                    app_type: "Team_Showcase",
                    settings: settingsArray,
            };
            
            //Api Call
            let api_response = await submitTemplate(payload);

            //Check Responce
            if (api_response.status === true) { 
                // Save templateId after first creation
                if (api_response.data.template_id) {
                    setTemplateId(api_response.data.template_id); 
                }
                setIsSubmitting(false); 
            } else {
                toast.error(api_response.message);
            }
        } catch (error) {
            toast.error('Oops Something Wrong. Please Try Again!' + error.message);
        }
  }; 

  const menuItems = [
      { key: "Content", icon: "content.png", label: "Content" },
      { key: "Layout", icon: "layout.png", label: "Layout" },
      { key: "Style", icon: "style.png", label: "Style" },
      { key: "Settings", icon: "settings.png", label: "Settings" },
  ];

  // Handle Source Tab input change
  const handleActiveTemplateInputChange = (event) => {
        setActiveTemplateSection(event.target.value);
        //Get the currently checked radio button
        const selectedRadio = document.querySelector('input[name="app_template_type"]:checked');
        if (selectedRadio) {
            const layoutTypeValue = selectedRadio.dataset.layout_type;
            const template_image = selectedRadio.dataset.template_image;
            setSelectedLayout(layoutTypeValue);
            setSelectedTemplateImage(template_image);
        } else {
            alert('Please select a template');
        }
    };

    //Update Form data
    const updateForm = async (e) => {
        e.preventDefault();

        setIsSubmitting(true);
        try {
            // Convert settings object back into an array of key-value pairs
            const updateSettingsArray = Object.entries(teamShowcaseTabData).map(([key, value]) => ({
                setting_key: key,
                setting_value: value,
            }));

            // Collect data from refs
            const payload = {
                template_id: isTemplateId,
                name: widgetName,
                template_name: activeTemplateSection,
                template_image: selectedTemplateImage,
                layout_name: selectedLayout,
                layout_type: selectedLayout,
                settings: updateSettingsArray,
            };
            
            //Api Call
            let api_response = await updateTemplateDetail(payload);

            //Check Responce
            if (api_response.status === true) {
                toast.success("Submitted Successfully.");
                // Redirect after 2 seconds
                setTimeout(() => {
                    navigate('/customer/apps/team-showcase');
                }, 2000); 
            } else {
                toast.error(api_response.message);
            }
        } catch (error) {
            toast.error('Oops Something Wrong. Please Try Again!' + error.message);
        }
    };

  return (
    <>
      <div className="create-goole-reviews-all">
            <CheckCurrentPlan from_page={true} app_name="Team Showcase" app_type="Team_Showcase" app_slug="team-showcase"/>
            {showTemplateSelection ? (
                <div className="create-goole-reviews-side">
                    <span>Select a template to start with</span>
                    <div className="card h-100">
                        <div className="label-box-flex">
                            <label className="card-radio-btn">
                                <input type="radio" name="app_template_type" className="card-input-element d-none" value="Company_Structure_Temp" data-layout_type="company_structure_layout" data-template_image="company-structure.png" checked={activeTemplateSection === "Company_Structure_Temp"} onChange={handleActiveTemplateInputChange} />
                                <div className="card card-body">
                                    <div className="content_head">
                                        <img src={`${process.env.PUBLIC_URL}/team-showcase/templates/company-structure.png`} alt="company-structure" />
                                    </div> 
                                    <div className="content_sub">Company Structure</div>
                                </div>
                            </label>
                            <label className="card-radio-btn">
                                <input type="radio" name="app_template_type" className="card-input-element d-none" value="Small_Team_Temp" data-layout_type="small_team_layout" data-template_image="small-team.png" checked={activeTemplateSection === "Small_Team_Temp"} onChange={handleActiveTemplateInputChange} />
                                <div className="card card-body">
                                    <div className="content_head">
                                        <img src={`${process.env.PUBLIC_URL}/team-showcase/templates/small-team.png`} alt="small-team" />
                                    </div> 
                                    <div className="content_sub">Small Team</div>
                                </div>
                            </label>
                            <label className="card-radio-btn">
                                <input type="radio" name="app_template_type" className="card-input-element d-none" value="Dedicated_Team_Temp" data-layout_type="dedicated_team_layout" data-template_image="dedicated-team.png" checked={activeTemplateSection === "Dedicated_Team_Temp"} onChange={handleActiveTemplateInputChange} />
                                <div className="card card-body">
                                    <div className="content_head">
                                        <img src={`${process.env.PUBLIC_URL}/team-showcase/templates/dedicated-team.png`} alt="dedicated-team" />
                                    </div> 
                                    <div className="content_sub">Dedicated Team</div>
                                </div>
                            </label>
                            <label className="card-radio-btn">
                                <input type="radio" name="app_template_type" className="card-input-element d-none" value="Music_Band_Temp" data-layout_type="music_band_layout" data-template_image="music-band.png" checked={activeTemplateSection === "Music_Band_Temp"} onChange={handleActiveTemplateInputChange} />
                                <div className="card card-body">
                                    <div className="content_head">
                                        <img src={`${process.env.PUBLIC_URL}/team-showcase/templates/music-band.png`} alt="music-band" />
                                    </div> 
                                    <div className="content_sub">Music Band</div>
                                </div>
                            </label>
                            <label className="card-radio-btn">
                                <input type="radio" name="app_template_type" className="card-input-element d-none" value="Team_Roster_Temp" data-layout_type="team_roster_layout" data-template_image="team-roster.png" checked={activeTemplateSection === "Team_Roster_Temp"} onChange={handleActiveTemplateInputChange} />
                                <div className="card card-body">
                                    <div className="content_head">
                                        <img src={`${process.env.PUBLIC_URL}/team-showcase/templates/team-roster.png`} alt="team-roster" />
                                    </div> 
                                    <div className="content_sub">Team Roster </div>
                                </div>
                            </label>
                            <label className="card-radio-btn">
                                <input type="radio" name="app_template_type" className="card-input-element d-none" value="Teachers_Temp" data-layout_type="teachers_layout" data-template_image="teachers.png" checked={activeTemplateSection === "Teachers_Temp"} onChange={handleActiveTemplateInputChange} />
                                <div className="card card-body">
                                    <div className="content_head">
                                        <img src={`${process.env.PUBLIC_URL}/team-showcase/templates/teachers.png`} alt="teachers" />
                                    </div> 
                                    <div className="content_sub">Teachers</div>
                                </div>
                            </label>
                        </div>
                    </div>
                    <div className="continue-template">
                        <button onClick={handleContinueTemplate}>Continue with this template</button>
                    </div>
                </div>
            ) : (
                <>
                    <div className="overlay-side-baar">
                        <div className="side-baar-inner-one">
                            <ul>
                                {menuItems.map((item) => (
                                    <li key={item.key}>
                                        <button
                                            className={activeSection === item.key ? "active" : ""}
                                            onClick={() => setActiveSection(item.key)}
                                        >
                                            <img
                                                src={`${process.env.PUBLIC_URL}/team-showcase/icons/${item.icon}`}
                                                alt={`${item.key} icon`}
                                            />
                                            <span>{item.label}</span>
                                        </button>
                                    </li>
                                ))}
                            </ul>
                        </div>
                        <div className="side-baar-inner-tow">
                            {/* Conditional Rendering for Sections */}
                            {activeSection === "Content" && (
                              <ContentTab isTemplateId={isTemplateId} setTemplateId={setTemplateId}  updateTeamShowcaseTabData={updateTeamShowcaseTabData} teamShowcaseTabData={teamShowcaseTabData} setRefreshWidgetList={setRefreshWidgetList} />
                            )}
                            {activeSection === "Layout" && (
                              <LayoutTab updateTeamShowcaseTabData={updateTeamShowcaseTabData} teamShowcaseTabData={teamShowcaseTabData} />
                            )}
                            {activeSection === "Style" && (
                              <StyleTab updateTeamShowcaseTabData={updateTeamShowcaseTabData} teamShowcaseTabData={teamShowcaseTabData} />
                            )}
                            {activeSection === "Settings" && (
                              <SettingsTab updateTeamShowcaseTabData={updateTeamShowcaseTabData} teamShowcaseTabData={teamShowcaseTabData} />
                            )}
                        </div>
                    </div>
                </>
            )}
            <div className="create-goole-reviews-right">
                <div className="content-wrapper count-add-class">
                    <div className="source-header-row">
                        <h2><Link to="/customer/apps/team-showcase"><i className="fa fa-angle-left" aria-hidden="true"></i> Back</Link></h2>
                        <div className="untitled-widget-name">
                            <button onClick={openRenameWidgetNamePopup} data-tooltip-id="rename-tooltip"><img src={`${process.env.PUBLIC_URL}/team-showcase/team-showcase.svg`} alt="team-showcase"/>{ widgetName }</button>
                            <Tooltip id="rename-tooltip" place="top" content="Rename Widget" />
                        </div>
                        <div className='submit-google-review'>
                          <button type="button" onClick={updateForm} className={`form-button ${isSubmitting ? 'disabled' : ''}`} disabled={isSubmitting}>Publish</button>
                          <Link to="/customer/apps/team-showcase/pricing/single" className="view-plan">View Plans</Link>
                          <Link to="/customer/apps/team-showcase" className="close-button">Close</Link></div> 
                    </div>
                    <div className="source-title-row">Team Showcase <i className="fa fa-angle-right" aria-hidden="true"></i> <strong>Connect</strong></div>

                    {/*Check template type*/}
                    {activeTemplateSection === "Company_Structure_Temp" && (
                      <CompanyStructureTemplateWidget isTemplateId={isTemplateId} teamShowcaseTabData={teamShowcaseTabData} refreshWidgetList={refreshWidgetList} />
                    )}
                    {activeTemplateSection === "Small_Team_Temp" && (
                      <SmallTeamTemplateWidget isTemplateId={isTemplateId} teamShowcaseTabData={teamShowcaseTabData} refreshWidgetList={refreshWidgetList} />
                    )}
                    {activeTemplateSection === "Dedicated_Team_Temp" && (
                      <DedicatedTeamTemplateWidget isTemplateId={isTemplateId} teamShowcaseTabData={teamShowcaseTabData} refreshWidgetList={refreshWidgetList} />
                    )}
                    {activeTemplateSection === "Music_Band_Temp" && (
                      <MusicBandTemplateWidget isTemplateId={isTemplateId} teamShowcaseTabData={teamShowcaseTabData} refreshWidgetList={refreshWidgetList} />
                    )}
                    {activeTemplateSection === "Team_Roster_Temp" && (
                      <TeamRosterTemplateWidget isTemplateId={isTemplateId} teamShowcaseTabData={teamShowcaseTabData} refreshWidgetList={refreshWidgetList} />
                    )}
                    {activeTemplateSection === "Teachers_Temp" && (
                      <TeachersTemplateWidget isTemplateId={isTemplateId} teamShowcaseTabData={teamShowcaseTabData} refreshWidgetList={refreshWidgetList}  />
                    )}
                </div>
            </div>
        </div>

        {/* Rename Popup */}
        {renameWidgetNameModel && (
            <div className="fixed top-50 left-50 w-full h-full bg-opacity-50 flex justify-center items-center popup-main rounded overflow-hidden widget-rename-model">
                <div className="bg-white p-3 rounded-lg shadow-lg">
                    <h3 className="text-lg font-semibold">Rename Widget</h3>
                    <label>Widget Name</label>
                    <input
                        type="text"
                        className="border p-2 w-full mt-2"
                        value={newWidgetName}
                        onChange={(e) => setNewWidgetName(e.target.value)}
                    />
                    <div className="mt-3 flex justify-end">
                        <button className="px-3 py-1 bg-gray-200 rounded mr-2" onClick={closeRenameWidgetNamePopup}>
                            Cancel
                        </button>
                        <button type="button" className="px-3 py-1 bg-blue-500 text-white rounded" onClick={saveWidgetName}>
                            Save
                        </button>
                    </div>
                </div>
            </div>
        )}
    </>
  );
} 